import constants from "../constants";

const {
  FETCH_LIST_MENU_ITEMS_DONE,
} = constants;

function filters(state = [], action) {
  switch (action.type) {
    case FETCH_LIST_MENU_ITEMS_DONE: {
      return [...action.data];
    }
    default: {
      return state;
    }
  }
}

export default filters;


// WEBPACK FOOTER //
// ./assets/list/reducers/menuItems.js